import { Message } from 'element-ui';
import store from '../store';

// 错误信息提示
const errorHandle = err => {
  if (err.response) {
    let { responseURL = '', status = '', statusText = '' } = err.response.request;
    switch (err.response.status) {
      case 400:
        console.log(err.response);
        break;
      case 401:
        Message.error('登录已过期，请重新登录');
        setTimeout(() => {
          store.commit('user/signOut', '1');
        }, 1000);
        break;
      default:
        Message({
          message: `[ ${status} ] [ ${statusText} ] [ ${responseURL} ]`,
          type: 'error',
          duration: 3000,
          showClose: true
        });
    }
  }
};

export default errorHandle;
